import moment from "moment";
import {
  createContext,
  useContext,
  useMemo,
  useState,
  ReactNode,
} from "react"

export interface Clientes {
  valor_vencido: string;
  data_ultimo_acionamento: string;
  data_agendamento: string;
  data_ultimo_whatsapp: string;
  button: JSX.Element;
  id_lista_loja: number;
  loja: number;
  cpf_cnpj: string;
  nome_cliente: string;
  nome_vendedor: string;
  atraso: number;
  valor_a_vencer: number;
  assessoria: string;
  id_processo: string;
  processo: string;
  fone1?: string;
  fone2?: string;
  fone3?: string;
  fone4?: string;
  fone5?: string;
  fone6?: string;
  fone7?: string;
  fone8?: string;
  email?: string;
  data_lista?: string;
  classificacao: string;
  uf?: string;
  cidade?: string;
  bairro?: string;
  logradouro?: string;
  numero?: string;
  complemento?: string;
}

interface CampaignContextData<T = any> {
  selectedClients: Set<string>
  setSelectedClients: React.Dispatch<React.SetStateAction<Set<string>>>

  queueLimit: string
  setQueueLimit: (value: string) => void

  isModalOpen: boolean
  setIsModalOpen: (open: boolean) => void

  hasCampaign: boolean
  setHasCampaign: (value: boolean) => void

  visibleClients: Clientes[]
  setVisibleClients: (clients: Clientes[]) => void

  selectClientsByCpf(cpfs: string[]): void
  applyQueueLimit: () => void
  clearSelection: () => void

  skippedTodayClients: string[]
  setSkippedTodayClients: React.Dispatch<React.SetStateAction<string[]>>
}

const WhatsAppCampaignContext = createContext<CampaignContextData | null>(null)

export function WhatsAppCampaignProvider({ children }: { children: ReactNode }) {
  const [selectedClients, setSelectedClients] = useState<Set<string>>(new Set())
  const [queueLimit, setQueueLimitState] = useState<string>("")
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [visibleClients, setVisibleClients] = useState<
    Clientes[]
  >([])
  const [hasCampaign, setHasCampaign] = useState(false)
  const [skippedTodayClients, setSkippedTodayClients] = useState<string[]>([])

  function isToday(data: string | Date) {
    if (!data) return false;

    return moment(data, "DD/MM/YYYY", true).isSame(moment(), "day");
  }

  function setQueueLimit(value: string) {
    setQueueLimitState(value)
  }

  function clearSelection() {
    setSelectedClients(new Set())
    setQueueLimitState("")
  }

  function selectClientsByCpf(cpfs: string[]) {
    setSelectedClients(new Set(cpfs))
  }

  function applyQueueLimit() {
    if (!visibleClients.length) return

    let limite = Number(queueLimit)
    if (!queueLimit || !limite || limite <= 0 || Number.isNaN(limite)) {
      limite = 0
    }

    const cpfs = visibleClients
      .filter(c => !isToday(c.data_ultimo_whatsapp)) // 🔥 pular hoje
      .slice(0, limite)
      .map(c => c.cpf_cnpj)

    setSelectedClients(new Set(cpfs))
  }

  // function applyQueueLimit() {
  //   if (!visibleClients || visibleClients.length === 0) {
  //     setSelectedClients(new Set())
  //     return
  //   }

  //   const limite = Number(queueLimit)

  //   const limiteFinal =
  //     !queueLimit || Number.isNaN(limite) || limite <= 0
  //       ? 0
  //       : Math.min(limite, visibleClients.length)


  //   const newSelected = new Set<string>()

  //   for (let i = 0; i < limiteFinal; i++) {
  //     newSelected.add(visibleClients[i].cpf_cnpj)
  //   }

  //   setSelectedClients(newSelected)

  // }

  const value = useMemo(
    () => ({
      selectedClients,
      setSelectedClients,
      queueLimit,
      setQueueLimit,
      isModalOpen,
      setIsModalOpen,
      applyQueueLimit,
      clearSelection,
      setVisibleClients,
      hasCampaign,
      setHasCampaign,
      visibleClients,
      selectClientsByCpf,
      skippedTodayClients,
      setSkippedTodayClients,
    }),
    [selectedClients, queueLimit, isModalOpen]
  )

  return (
    <WhatsAppCampaignContext.Provider value={value}>
      {children}
    </WhatsAppCampaignContext.Provider>
  )
}

export function useWhatsAppCampaign() {
  const context = useContext(WhatsAppCampaignContext)
  if (!context) {
    throw new Error(
      "useWhatsAppCampaign deve ser usado dentro de WhatsAppCampaignProvider"
    )
  }
  return context
}